import { render, staticRenderFns } from "./PortfolioTable.vue?vue&type=template&id=332a5870&scoped=true&"
import script from "./PortfolioTable.vue?vue&type=script&lang=js&"
export * from "./PortfolioTable.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioTable.vue?vue&type=style&index=0&id=332a5870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a5870",
  null
  
)

export default component.exports